import http from '../common/api';
import {ApiSettings} from "application";

const getSitesMapInfo = async () => {
  return await http.get(ApiSettings.getNodeExtraInfo);
}

export default getSitesMapInfo;
